import React from 'react';
const Fieldset = ({ children, label, isError, required }) => {
  return (
    <fieldset className={isError ? 'custom-fieldset-error' : 'custom-fieldset'}>
      <legend className="same-font-family">
        <span style={{ color: isError ? '#dc3545' : '' }}> {label}</span>
        <span className="mandatory"> {required ? '*' : ''}</span>
      </legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
